module.exports = "/_next/static/images/pizza_marinala-fee9ded8818609e371c6d6ba277abb31.jpg";